import React from 'react';

import { ProductEntityLink, TeamEntityLink, CapabilityEntityLink } from '@/components/primitive';
import { FCC } from '@/utils/types';

import { SearchableType, Params, Term } from '../types';
import Scope from '../scope';
import CrossCircleIconButton from '../cross-circle-icon-button';
import actionCreators from '../stores/query/action-creators';

import * as styles from './styles';

function renderComma(items: Term[], index: number) {
  return index !== items.length - 1 ? ',' : '';
}

function renderTerm({ scope, name, publicId }: { scope: SearchableType } & Term) {
  return {
    team: <TeamEntityLink name={name} publicId={publicId} />,
    product: <ProductEntityLink name={name} publicId={publicId} />,
    capability: <CapabilityEntityLink name={name} publicId={publicId} />,
  }[scope];
}

export const SelectedParam: FCC = ({ children }) => <div css={styles.param}>{children}</div>;

interface SelectedParamsProps {
  params: Params;
  removeParam: typeof actionCreators['removeParam'];
}

const SelectedParams: React.FC<SelectedParamsProps> = ({
  params,
  removeParam,
}: SelectedParamsProps) => {
  const paramsKeys = Object.keys(params);
  return (
    <div css={styles.root}>
      {Object.keys(params).map((scope: SearchableType, index: number) => (
        <React.Fragment key={scope}>
          <SelectedParam>
            <Scope scope={scope} />
            <span css={styles.terms}>
              {Object.values(params[scope]).map((term, i) => (
                <React.Fragment key={term.name}>
                  {renderTerm({ scope, name: term.name, publicId: term.publicId })}
                  &nbsp;{renderComma(params[scope], i)}&nbsp;
                </React.Fragment>
              ))}
            </span>
            <CrossCircleIconButton
              clearInputValue={() => removeParam({ scope })}
              className="clearInput"
            />
          </SelectedParam>
          {index !== paramsKeys.length - 1 && <em>OR</em>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SelectedParams;
